import { useCallback } from 'react';

import { IconEuro } from '@iwoca/icons';
import { Input, Label, Tooltip } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { TCompanyDetailsDataDE } from './CompanyDetailsDE';
import companyDetailsStyles from './CompanyDetailsDE.module.css';
import { useIsInDECompanySearchUITest } from '../../../hooks/useIsInDECompanySearchUITest';

const TurnoverInputDE = () => {
  const { t } = useLingui();

  const { isIncludedInCompanySearchUITest } = useIsInDECompanySearchUITest();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataDE>();

  const formatCurrency = useCallback(() => {
    const amount = watch('last12MonthsTurnover')?.replace(/[^0-9]+/g, '');
    if (!amount) return '';

    return parseInt(amount).toLocaleString('de-DE');
  }, [watch]);

  return (
    <>
      <div className={companyDetailsStyles.formLabel}>
        <Label htmlFor="last12MonthsTurnover">
          <Trans>Last 12 months’ turnover</Trans>
        </Label>
        <Tooltip
          data-testid="turnover-tooltip"
          content={
            isIncludedInCompanySearchUITest
              ? t`If you have been trading for less than a year, enter your total revenue to date.`
              : t`If you have been trading for less than a year, enter your total turnover to date.`
          }
        />
      </div>
      <Input
        {...register('last12MonthsTurnover')}
        value={formatCurrency()}
        placeholder={t`e.g. 500,000`}
        id={'last12MonthsTurnover'}
        type="text"
        iconRight={<IconEuro />}
        error={
          errors?.last12MonthsTurnover?.message &&
          errors.last12MonthsTurnover.message
        }
      />
    </>
  );
};

export default TurnoverInputDE;
